// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__9x9Ra","footer":"ReportModalFilter_footer__1vrnP"};